import {
  // AirportShuttle,
  AllInbox,
  Apps,
  BarChart,
  // Build,
  Category,
  ColorLens,
  CropFree,
  Dashboard,
  KeyboardReturn,
  // DoubleArrow,
  SwapHoriz,
  FilterList,
  AddShoppingCart,
  ListAlt,
  Note,
  People,
  PeopleAlt,
  Receipt,
  ShoppingCart,
  Storage,
  Store,
  SupervisedUserCircle,
  SupervisorAccount,
  SwapVerticalCircle,
  ViewCompact,
  ListAltSharp,
  Payment,
  MoneyOff,
  AccountBalanceOutlined

} from "@mui/icons-material";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import TurnRightIcon from "@mui/icons-material/TurnRight";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import { green, red } from "@mui/material/colors";
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import ReplayIcon from '@mui/icons-material/Replay';
import CheckIcon from "@mui/icons-material/Check";
import LabelImportantIcon from '@mui/icons-material/LabelImportant';
import InventoryIcon from '@mui/icons-material/Inventory';

export const menuConfigPOS = [
  {
    settings: {},
    auth: "admin",
    menus: [
      {
        label: "Dashboard",
        value: "Dashboard",
        path: "/dashboard",
        icon: <Dashboard />,
        children: [],
      },
      {
        label: "Invoice",
        value: "Sales",
        path: "/sales",
        icon: <ShoppingCart />,
        children: [],
      },

      {
        label: "Stock",
        value: "",
        path: "/stock",
        icon: <Store />,
        children: [
          {
            label: "GRN",
            value: "",
            path: "/grn",
            icon: <Note />,
            children: [
              {
                label: "GRN",
                value: "grn",
                path: "/grn",
                icon: <Note sx={{ color: red[500] }} />,
                children: [],
              },
              {
                label: "Paid",
                value: "grn-paid",
                path: "/grn-paid",
                icon: <Note sx={{ color: green[500] }} />,
                children: [],
              },
            ],
          },
          {
            label: "Mature Stock",
            value: "Mature Stock",
            path: "/matureStock",
            icon: <CheckBoxOutlineBlankOutlinedIcon />,
            children: [],
          },
          {
            label: "Transfer",
            value: "Transfer",
            path: "/stock-transfer",
            icon: <SwapHoriz />,
            children: [],
          },
          {
            label: "Stock In",
            value: "StockIn",
            path: "/stock-in",
            icon: <LabelImportantIcon />,
            children: [],
          },
          {
            label: "Stock Dashboard",
            value: "StockDashboard",
            path: "/stock-dashboard",
            icon: <InventoryIcon />,
            children: [],
          },
          {
            label: "Sales Order",
            value: "salesOrder",
            path: "/sales-order",
            icon: <AddShoppingCart />,
            children: [],
          },
          {
            label: "Sales Quotation",
            value: "quotation",
            path: "/sales-quotation",
            icon: <ListAltSharp />,
            children: [],
          },
          {
            label: "Stock Issue",
            value: "Stock-Issue",
            path: "/stock-issue",
            icon: <TurnRightIcon />,
            children: [],
          },
        ],
      },

      {
        label: "Item & Services",
        value: "Stocks",
        path: "/",
        icon: <Storage />,
        children: [
          {
            label: "Item & Service",
            value: "ItemMaster",
            path: "/item-master",
            icon: <Storage />,
            children: [],
          },

          {
            label: "Category",
            value: "Category",
            path: "/item-category",
            icon: <Category />,
            children: [],
          },
          {
            label: "Brand",
            value: "Brand",
            path: "/item-brand",
            icon: <Apps />,
            children: [],
          },
          {
            label: "Bin Location",
            value: "Bin",
            path: "/item-bin",
            icon: <AllInbox />,
            children: [],
          },
          {
            label: "Colour",
            value: "Colour",
            path: "/item-colour",
            icon: <ColorLens />,
            children: [],
          },
          {
            label: "Unit",
            value: "Unit",
            path: "/item-unit",
            icon: <FilterList />,
            children: [],
          },
        ],
      },
      {
        label: "Customers",
        value: "Customers",
        path: "customers",
        icon: <People />,
        children: [
          {
            label: "Customer",
            value: "Customer",
            path: "/customer",
            icon: <PeopleAlt />,
            children: [],
          },
          {
            label: "Payment Receipt",
            value: "payment-receipt",
            path: "/payment-receipt",
            icon: <Receipt />,
            children: [],
          },
          {
            label: "Receipt Reversal",
            value: "receipt-reversal",
            path: "/receipt-reversal",
            icon: <Receipt sx={{ color: red[500] }} />,
            children: [],
          },
          // {
          //   label: "Invoice Reversal",
          //   value: "invoice-reversal",
          //   path: "/invoice-reversal",
          //   icon: <CloseOutlinedIcon sx={{ color: red[500] }} />,
          //   children: [],
          // },
          {
            label: "Sales Return",
            value: "sales-return",
            path: "/sales-return",
            icon: <KeyboardReturn />,
            children: [],
          },
        ],
      },
    
      {
        label: "Cheque Receipts",
        value: "cheque",
        path: "/cheque",
        icon: <LocalAtmIcon />,
        children: [
          {
            label: "Cheques in hand",
            value: "cheque",
            path: "/cheques",
            icon: <LocalAtmIcon color="success" />,
            children: [],
          },
          {
            label: "Cheques in Deposit",
            value: "cheque",
            path: "/cheques-process",
            icon: <LocalAtmIcon color="info" />,
            children: [],
          },
          {
            label: "Realized Cheques",
            value: "cheque",
            path: "/cheque-realized",
            icon: <CheckIcon color="success" />,
            children: [],
          },
          {
            label: "Returned Cheques",
            value: "cheque",
            path: "/returned-cheque",
            icon: <LocalAtmIcon color="error" />,
            children: [],
          },
         
        ],
      },
      {
        label: "RTN Cheque Pay",
        value: "cheque",
        path: "/chequePayment",
        icon: <ReplayIcon />,
        children: [
          {
            label: "Cheque Receipt",
            value: "cheque",
            path: "/chequePayment",
            icon: <PriceCheckIcon />,
            children: [],
          },
        
        
        ],
      },
    
      {
        label: "Suppliers",
        value: "Suppliers",
        path: "/",
        icon: <SupervisorAccount />,
        children: [
          {
            label: "Suppliers",
            value: "Supplier",
            path: "/suppliers",
            icon: <SupervisorAccount />,
            children: [],
          },
          {
            label: "Payment Vouchers",
            value: "payment-vouchers",
            path: "/payment-vouchers",
            icon: <Payment />,
            children: [],
          },
          {
            label: "Voucher Reversal",
            value: "voucher-reversal",
            path: "/voucher-reversal",
            icon: <Payment sx={{ color: red[500] }} />,
            children: [],
          },
          {
            label: "Purchase Return",
            value: "purchase-return",
            path: "/purchase-return",
            icon: <MoneyOff />,
            children: [],
          },
        ],
      },
      {
        label: "Cheque Vouchers",
        value: "cheque",
        path: "/cheque-vouchers",
        icon: <LocalAtmIcon />,
        children: [
          {
            label: "Cheques in hand",
            value: "cheque",
            path: "/cheque-vouchers",
            icon: <LocalAtmIcon color="success" />,
            children: [],
          },
          {
            label: "Cheques in Process",
            value: "cheque",
            path: "/cheque-vouchers-process",
            icon: <LocalAtmIcon color="info" />,
            children: [],
          },
          {
            label: "Returned Cheques",
            value: "cheque",
            path: "/returned-cheque-vouchers",
            icon: <LocalAtmIcon color="error" />,
            children: [],
          },
        ],
      },
      {
        label: "Sales Rep",
        value: "salesReps",
        path: "/salesRep",
        icon: <SupervisedUserCircle />,
        children: [
          {
            label: "Sales Rep",
            value: "salesRep",
            path: "/salesRep",
            icon: <SupervisedUserCircle />,
            children: [],
          },
          {
            label: "Route",
            value: "route",
            path: "/route",
            icon: <SwapVerticalCircle />,
            children: [],
          },
        ],
      },
      {
        label: "Reports",
        value: "Reports",
        path: "/reports",
        icon: <BarChart />,
        children: [],
      },
      {
        label: "Barcode",
        value: "",
        path: "/barcode",
        icon: <CropFree />,
        children: [],
      },
      {
        label: "Expenses",
        value: "Expenses",
        path: "/",
        icon: <ViewCompact />,
        children: [
          {
            label: "Expenses",
            value: "Expense",
            path: "/expenses",
            icon: <ViewCompact />,
            children: [],
          },
          
          {
            label: "Expenses Categories",
            value: "expanses-category",
            path: "/expanses-category",
            icon: <ListAlt />,
            children: [],
          },
        ],
      },
      {
        label: "Accounts",
        value: "accounts",
        path: "/",
        icon: <CalculateOutlinedIcon />,
        children: [
          {
            label: "Debit/Credit",
            value: "CreditAndDebit",
            path: "credit-and-debit",
            icon: <CalculateOutlinedIcon />,
            children: [],
          },
          {
            label: "Journal Type",
            value: "CreditAndDebit",
            path: "/journal-types",
            icon: <CalculateOutlinedIcon />,
            children: [],
          },
          {
            label: "General Ledger",
            value: "GeneralLEdger",
            path: "/general-ledger",
            icon: <AccountBalanceOutlined />,
            children: [],
          },
        ],
      },
      
      // {
      //   label: "Settings",
      //   value: "Settings",
      //   path: "/settings",
      //   icon: <Settings/>,
      //   children: [],
      // },
      // {
      //   label: "Users",
      //   value: "Users",
      //   path: "/",
      //   icon: <Person/>,
      //   children: [
      //     {
      //       label: "Users",
      //       value: "User",
      //       path: "/user",
      //       icon: <Person/>,
      //       children: [],
      //     },
      //     {
      //       label: "User Type",
      //       value: "user-type",
      //       path: "/user-type",
      //       icon: <GroupAdd/>,
      //       children: [],
      //     },
      //   ],
      // },
    ],
  },
  {
    settings: {},
    auth: "cashier",
    menus: [
      {
        label: "Invoice",
        value: "Sales",
        path: "/sales",
        icon: <ShoppingCart />,
        children: [],
      },

      {
        label: "Customers",
        value: "Customers",
        path: "customers",
        icon: <People />,
        children: [
          {
            label: "Customer",
            value: "Customer",
            path: "/customer",
            icon: <PeopleAlt />,
            children: [],
          },
          {
            label: "Payment Receipt",
            value: "payment-receipt",
            path: "/payment-receipt",
            icon: <Receipt />,
            children: [],
          },
        ],
      },
      {
        label: "Barcode",
        value: "",
        path: "/barcode",
        icon: <CropFree />,
        children: [],
      },
    ],
  },
];

export const SecondaryMenu = [];